import { Route } from "react-router-dom";
import { _adr } from "../address";
import { Roles } from "../tools/services";
import { ProtectedRoute } from "../tools/protectedRoute";
import SearchCorporate from "../components/corporate_subscriber_search/corporate/search/SearchCorporate";
import UpdateNetwork from "../components/corporate_subscriber_search/corporate/UpdateMobileNetwork/UpdateNetwork";
import ActionSubscriber from "../components/corporate_subscriber_search/corporate/ActionSubscriber/ActionSubscriber";
import CoSimKit from "../components/corporate_subscriber_search/corporate/CoSimSwap/kit/CoSimKit";
import CoSimPrefactor from "../components/corporate_subscriber_search/corporate/CoSimSwap/prefactor/CoSimPrefactor";
import CoSimFinal from "../components/corporate_subscriber_search/corporate/CoSimSwap/final/CoSimFinal";
import CowProfile from "../components/corporate_subscriber_search/corporate/CoChangeOwnerShip/Profile/CowProfile";
import CowUpload from "../components/corporate_subscriber_search/corporate/CoChangeOwnerShip/Upload/CowUpload";
import CowReview from "../components/corporate_subscriber_search/corporate/CoChangeOwnerShip/Review/CowReview";
import CowFinal from "../components/corporate_subscriber_search/corporate/CoChangeOwnerShip/Final/CowFinal";
import CoChangeSimStatus from "../components/corporate_subscriber_search/corporate/coChangeSimStatus/coChangeSimStatus.jsx";

export const corporateRoutes = [
	<Route
		key="corporate-search"
		path={_adr.Root + _adr.Corporate.Index + _adr.Corporate.Search}
		element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={SearchCorporate} />}
	/>,
	<Route
		key="corporate-update-network"
		path={_adr.Root + _adr.Corporate.Index + _adr.Corporate.UpdateNetwork}
		element={<ProtectedRoute role={Roles.Dealer_UpdateMobile_Network} element={UpdateNetwork} />}
	/>,
	<Route
		key="corporate-change-status-sim"
		path={_adr.Root + _adr.Corporate.Index + _adr.Corporate.ChangeStatusSim}
		element={<ProtectedRoute role={Roles.Dealer_UpdateMobile_Network} element={CoChangeSimStatus} />}
	/>,
	<Route
		key="corporate-action"
		path={_adr.Root + _adr.Corporate.Index + _adr.Corporate.Action}
		element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={ActionSubscriber} />}
	/>,

	// تعویض سیم‌کارت حقوقی
	<Route
		key="corporate-simswap-kit"
		path={_adr.Root + _adr.Corporate.Index + _adr.Corporate.SimSwap.Index + _adr.Corporate.SimSwap.ValidKit}
		element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={CoSimKit} />}
	/>,
	<Route
		key="corporate-simswap-prefactor"
		path={_adr.Root + _adr.Corporate.Index + _adr.Corporate.SimSwap.Index + _adr.Corporate.SimSwap.PreFactor}
		element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={CoSimPrefactor} />}
	/>,
	<Route
		key="corporate-simswap-final"
		path={_adr.Root + _adr.Corporate.Index + _adr.Corporate.SimSwap.Index + _adr.Corporate.SimSwap.Final}
		element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={CoSimFinal} />}
	/>,

	// تغییر مالکیت حقوقی
	<Route
		key="corporate-ownership-profile"
		path={_adr.Root + _adr.Corporate.Index + _adr.Corporate.Ownership.Index + _adr.Corporate.Ownership.Profile}
		element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={CowProfile} />}
	/>,
	<Route
		key="corporate-ownership-upload"
		path={_adr.Root + _adr.Corporate.Index + _adr.Corporate.Ownership.Index + _adr.Corporate.Ownership.Upload}
		element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={CowUpload} />}
	/>,
	<Route
		key="corporate-ownership-review"
		path={_adr.Root + _adr.Corporate.Index + _adr.Corporate.Ownership.Index + _adr.Corporate.Ownership.Review}
		element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={CowReview} />}
	/>,
	<Route
		key="corporate-ownership-final"
		path={_adr.Root + _adr.Corporate.Index + _adr.Corporate.Ownership.Index + _adr.Corporate.Ownership.Final}
		element={<ProtectedRoute role={Roles.Dealer_SearchB2B_Subscription} element={CowFinal} />}
	/>,
];
